<template>
  <div class="exchange-i">
    <Header title="毕业设计" type="0" route="/student/design"></Header>
    <div class="list-head">
              <div>
                <p>年度：{{designReCodeList.baseMsg.jb}}</p>
                <p>指导老师：{{designReCodeList.baseMsg.teachername}}</p>
                <p>设计（论文）题目：{{designReCodeList.baseMsg.topicname}}</p>
              </div>
     </div>
    <div class="exchange" v-if="designReCodeList.msgDealList&&designReCodeList.msgDealList.length>0">
      <div
        class="item"
        v-for="(item, index) of designReCodeList.msgDealList"
        :key="index" 
        @click="toGuideal(item)"
      >
        <ul>
          <li><label>提问内容：{{item.requstcontext}}</label></li>
          <li><label>时间：{{item.creattime}}</label></li>
          <li v-if="item.type=='1'"><label>回复状态：{{item.staute}}</label></li>
          <li v-else><label>审核状态：{{item.staute}}</label></li>
        </ul>
      </div>
    </div>
    <div class="bottom-btn">
      <button @click="addQustMsg">新增</button>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      designReCodeList: {'baseMsg':{'jb':'','teachername':'','topicname':''}},
    };
  },
  methods: {
    async loadMyDesignMsgDeal(){
      const params = {
        type: this.$route.query.type,
        ywstid:this.$route.query.ywstid,
      };
      const res = await Api.loadMyDesignMsgDeal(params);
      if(res.code=='1'){
        this.designReCodeList = res.data;
      }
    },
    toGuideal(item){
      if(item.type=='2'){
        this.$router.push({
          path: "/student/myGuideDeal_unload",
          query: {
            ywstid: item.sj110401id,
            type: item.type,
            curseid:this.$route.query.ywstid,
          }
        });
      }else{
        this.$router.push({
          path: "/student/MyGuideDeal",
          query: {
            ywstid: item.sj110401id,
            type: item.type,
            curseid:this.$route.query.ywstid,
          }
        });
      }
      
    },
    addQustMsg(){
      if(this.$route.query.type=='2'){
        this.$router.push({
          path: "/student/addQustMsg_unline",
          query: {
            type: this.$route.query.type,
            ywstid:this.$route.query.ywstid,
            studentnumber:this.designReCodeList.baseMsg.studentnumber,
            studentname:this.designReCodeList.baseMsg.studentname,
            topicname:this.designReCodeList.baseMsg.topicname
          }
        });
      }else{
        this.$router.push({
          path: "/student/addQustMsg",
          query: {
            type: this.$route.query.type,
            ywstid:this.$route.query.ywstid,
            studentnumber:this.designReCodeList.baseMsg.studentnumber,
            studentname:this.designReCodeList.baseMsg.studentname,
            topicname:this.designReCodeList.baseMsg.topicname
          }
        });
      }
    }
  },
  created() {
    this.loadMyDesignMsgDeal();
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .list-head {
      height: 100px;
      background-image: url("../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding-left: 6%;
      padding-top: 2%;
      box-sizing: border-box;
      margin-bottom: 1%;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      div {
        width: 90%;
        height: 100%;
        p {
          font-size: 14px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        
      
        span {
          align-items: center;
          i {
            font-style: normal;
            font-size: 14px;
            color: #fff;
            margin-right: 5%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 80%;
            margin-left: 15px;
          }
          b {
            display: inline-block;
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;
            border-top: 3px solid #fff;
          }
        }
      }
    }
  .exchange {
    padding: 5% 5% 0;
    overflow: auto;
    height: 70vh;
    .item {
      background: #f8f8f8;
      border-radius: 8px;
      margin: 0 auto 5%;
      padding: 3% 0 3% 6%;
      box-sizing: border-box;

      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      ul {
        li {
          font-family: PingFangSC-Light;
          font-size: 14px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 2%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
          min-height: 16px;
        }

        li label {
          height: 16px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          line-height: 16px;
          margin-bottom: 1%;
          margin-top: 1%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
        }

        .lableBut{
          color: #0632f8;
          margin-top: 2%;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/Design/to_guideRecode.vue